import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `POST …/generations` carries no body: the target is entirely in the URL. */
class LaunchWorkflowRunGeneration {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly runId: number,
	) {
		Object.freeze(this);
	}
}

export default LaunchWorkflowRunGeneration;
